import {ExpandingTextArea} from './ExpandingTextArea';

export {ExpandingTextArea};
